<template>
	<div>
		<q-dialog v-model="dialog" persistent transition-show="scale" transition-hide="scale">
			<div class="hris-modal">
				<q-form ref="vForm" @submit="addUser">
					<div class="hris-modal-header">
						<h2 class="hris-modal-title">Edit User</h2>
					</div>
					<div class="hris-modal-body">
						<div class="hris-form-field q-mb-md">
							<q-input v-model="models.firstname" label="First Name" outlined dense color="green" class="caps"></q-input>
						</div>
						<div class="hris-form-field q-mb-md">
							<q-input v-model="models.middlename" label="Middle Name" outlined dense color="green" class="caps"></q-input>
						</div>
						<div class="hris-form-field q-mb-md">
							<q-input v-model="models.lastname" label="Last Name" outlined dense color="green" class="caps"></q-input>
						</div>
						<div class="hris-form-field q-mb-md">
							<q-input v-model="models.email" label="Email" outlined dense color="green"></q-input>
						</div>
						<div class="hris-form-field q-mb-md">
							<q-select v-model="models.role" option-value="role_id" option-label="name" :options="ranks" label="Rank" outlined dense color="green" emit-value map-options class="caps"></q-select>
						</div>
						<div class="hris-form-field q-mb-md">
							<q-input v-model="models.username" label="Username" outlined dense color="green"></q-input>
						</div>
						<div class="hris-form-field">
							<q-input v-model="models.password" type="password" label="Password" outlined dense color="green"></q-input>
						</div>
					</div>

					<div class="hris-modal-footer">
						<q-btn flat label="Close" class="hris-q-ghost" @click="closeModal"></q-btn>
						<q-btn unelevated label="Submit" type="submit" class="hris-q-primary"></q-btn>
					</div>
				</q-form>
			</div>
		</q-dialog>
		<q-dialog v-model="spinner" persistent>
			<div class="hris-loading" style="background: var(--hris-surface); border-radius: var(--hris-radius); padding: 32px 44px;">
				<q-spinner color="green" size="40px"></q-spinner>
			</div>
		</q-dialog>
	</div>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';

export default {

	data() {
		return {
			spinner: false,
			models : {
				firstname:null,
				middlename:null,
				lastname:null,
				username:null,
				password:null,
				email: null,
				role:null,
				id:null
			},
			dialog: false,
			user_id : null,
			ranks:[]
		}
	},
	created(){
		this.eventHub.$on('EditUserAccount', this.openModal);
		this.displayRanks()
	},

	methods: {
		addUser:function(){
			this.spinner=true;
			let formData = new FormData();
			formData.append("id", this.models.id);
			formData.append("firstname", this.models.firstname);
			formData.append("middlename", this.models.middlename);
			formData.append("lastname", this.models.lastname);
			formData.append("username", this.models.username);
			formData.append("email", this.models.email);
			formData.append("role", this.models.role);
			formData.append("password", this.models.password);
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/admin/update',formData)
			.then((res) => {
				
				if(res.data.status){
					this.$q.notify({
						message: 'User successfully updated.',
						color: 'positive',
						actions: [
					{ label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
					]
				});
					this.eventHub.$emit('refreshEmployeeList',"");
				}else{
					this.$q.notify({
						message: 'Failed to update a user.',
						color: 'negative',
						actions: [
					{ label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
					]
				})
				}

				this.spinner=false;
				return true;
			});

			

		},

		displayRanks: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/users`)
			.then((res) => {
				
				this.ranks = res.data.ranks
				this.ranks.unshift({'role_id':1,'name':'ALL'})			
			})

		},

		openModal:function(props){
			
			this.dialog = true;
			this.models.id	=	props.employee.row.id;
			this.models.firstname	=	props.employee.row.firstname;
			this.models.middlename	=	props.employee.row.middlename;
			this.models.lastname	=	props.employee.row.lastname;
			this.models.username	=	props.employee.row.username;
			this.models.email		=	props.employee.row.email;
			this.models.role		=	props.employee.row.role_id;
		},

		closeModal:function(){
			this.dialog = false;

		}
	}
}
</script>
<style lang="css" scoped>
</style>